export default {
  SET_LOADING(state, data) {
    state.showLoading = data
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js